import React from "react";

const ReferralReminders = () => {
  return (
    <div className="automation-section">
      <div className="automation-section-title">Referral Reminders</div>
      <div className="automation-row">
        <div className="">
          <span className="automation-label">
            Send Reminder After (days)
          </span>
          <input
            type="text"
            className="automation-input"
            placeholder="Enter days"
          />
        </div>
        <div className="">
          <span className="automation-label">
            Second Reminder After (days)
          </span>
          <input
            type="text"
            className="automation-input"
            placeholder="Enter days"
          />
        </div>
      </div>
    </div>
  );
};

export default ReferralReminders;
